module.exports = __webpack_public_path__ + "img/H-T-6-unload-standup-shadow.e886e20b.png";